module.exports = __webpack_public_path__ + "static/media/main_bg_2.bba3e97f.jpg";